import { baseApi } from "@/shared/api";
import type { ContractStatus, ContractUploadResponse } from "./types";

export const contractApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getContractStatus: builder.query<ContractStatus, string>({
      query: (token) => ({
        url: `/api/hr/apply/${token}/contract/`,
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: ["Completeness"],
    }),

    uploadContract: builder.mutation<ContractUploadResponse, { token: string; file: File }>({
      query: ({ token, file }) => {
        const form = new FormData();
        form.append("contract_file", file);

        return {
          url: `/api/hr/apply/${token}/contract/`,
          method: "POST",
          body: form,
          credentials: "include" as const,
        };
      },
      invalidatesTags: ["Completeness"],
    }),
  }),
});

export const { useGetContractStatusQuery, useUploadContractMutation } = contractApi;
